import { Box, FlexLayout, H3, H4 } from '@deity/falcon-ui';
import { Button, Icon } from '@deity-io/portal-ui';
import { Skeleton } from '@material-ui/lab';
import { ENTITY_PATH, ENTITY_PATH_ID } from 'contracts/constants';
import type { Dispatch, FC, SetStateAction } from 'react';
import { useLocation } from 'react-router-dom';
import { getParams } from 'utils';

type EntityDetailsHeaderProps = {
  isLoading: boolean;
  name: string | undefined;
  description: string | undefined | null;
  onModalOpen?: Dispatch<SetStateAction<boolean>>;
  endEnhancer?: JSX.Element;
  isEditable?: boolean;
};
export const EntityDetailsHeader: FC<EntityDetailsHeaderProps> = ({
  name,
  description,
  onModalOpen,
  isLoading,
  isEditable = false,
  endEnhancer
}) => {
  const { pathname } = useLocation();
  // eslint-disable-next-line react/no-unstable-nested-components
  const Loading: FC<{ height: string }> = ({ height }) => <Skeleton width="100%" height={height} />;
  const params = getParams(pathname, [ENTITY_PATH_ID, ENTITY_PATH]);

  // const { data, loading } = useGetPackageVersionQuery({
  //   variables: {
  //     versionUuid: params?.versionUuid
  //   },
  //   ...CACHE_FIRST
  // });

  // const isEditable: boolean = data?.getPackageVersion.status
  //   ? isPackageEditable(data?.getPackageVersion.status)
  //   : false;

  return (
    <Box p="xxl">
      <FlexLayout justifyContent="space-between" width="full">
        <Box>
          <FlexLayout flexDirection="column">
            <H3 color="secondary" fontWeight="bold" fontSize="xs">
              NAME
            </H3>
            <FlexLayout alignItems="center" width="full">
              {isLoading ? (
                <Loading height="36.39px" />
              ) : (
                <>
                  <H4 color="primaryText" fontSize={'xll' as any} mr="sm">
                    {name}
                  </H4>
                  {isEditable && (
                    <Button
                      startIcon={<Icon icon="edit" />}
                      color="primary"
                      onClick={() => {
                        if (onModalOpen) {
                          onModalOpen(true);
                        }
                      }}
                    />
                  )}
                </>
              )}
            </FlexLayout>
          </FlexLayout>
          <H3 color="secondary" fontWeight="bold" fontSize="xs" mt="md">
            DESCRIPTION
          </H3>
          {isLoading ? <Loading height="23.4px" /> : <H3>{description}</H3>}
        </Box>
        <Box>{endEnhancer}</Box>
      </FlexLayout>
    </Box>
  );
};
